<template>
  <div>
    <div v-if="isBookingExpress && !$q.screen.gt.sm" class="text-bold text-center demand-booking-favoris q-mb-sm">
      <QIcon name="icon-extra-beacon" />
      {{ $t("ETAB.PAGES.RECRUITMENT.TILE.@DEMAND_BOOKING_EXPRESS") }}
    </div>
    <div class="candidate-small-card" :class="{'placeholder-candidate': placeholder}">
      <span v-if="candidate.isCancelledStatus()" class="bg-negative"><QIcon name="icon-f-alert-triangle" /></span>
      <template v-if="candidate.isContactedStatus() || candidate.isSelectedStatus()">
        <span class="bg-positive"><QIcon :name="selectedIcon" size="14px" /></span>
      </template>
      <Avatar :picture="candidate.getPicture()" size="64px" />
      <p v-if="isAlone" class="text-bold">
        {{ candidate.getFirstname() }}
      </p>
    </div>
  </div>
</template>

<script>
import { CandidateDashboardModel } from "@core/models";

export default {
  props: {
    candidate: {
      type: Object,
      default: () => new CandidateDashboardModel(),
    },
    placeholder: {
      type: Boolean,
      default: false,
    },
    isAlone: {
      type: Boolean,
      default: false,
    },
    selectedIcon: {
      type: String,
      default: "icon-f-check",
    },
    isBookingExpress: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.candidate-small-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &.placeholder-candidate {
    opacity: 0.15;
  }

  > span {
    position: absolute;
    top: -5px;
    left: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    color: white;
    text-align: center;
    font-size: 18px;

    &.bg-negative {
      font-size: 17px;
      padding-bottom: 2px; // fix wrong icon position
    }
  }

  img {
    margin: 0 5px;
    box-shadow: $img-shadow;
  }

  > p {
    margin: 0 10px;
    color: $primary;
  }
}
</style>
